import { render, staticRenderFns } from "./SlidingBayBrokenTiles.vue?vue&type=template&id=2b33ce6a&scoped=true"
import script from "./SlidingBayBrokenTiles.vue?vue&type=script&lang=ts"
export * from "./SlidingBayBrokenTiles.vue?vue&type=script&lang=ts"
import style0 from "./SlidingBayBrokenTiles.vue?vue&type=style&index=0&id=2b33ce6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b33ce6a",
  null
  
)

export default component.exports